import { render } from "./CorporativoView.vue?vue&type=template&id=12c44ee8"
import script from "./CorporativoView.vue?vue&type=script&lang=js"
export * from "./CorporativoView.vue?vue&type=script&lang=js"

import "./CorporativoView.vue?vue&type=style&index=0&id=12c44ee8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__